import { useContext } from 'react';
import ApiContext from '../context/api/ApiContext';

export const useApi = () => {
  return useContext(ApiContext);
};
